import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ensureProjectKey } from '../../actions';

/**
 * Browser start screen
 *
 * Allows for entering a project title and getting started
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */
const Start = ({ onStart = () => {}, dispatch, currentBuildIndex }) => {
    useEffect(() => {
        dispatch(ensureProjectKey(currentBuildIndex));
        onStart();
    }, [onStart, dispatch, currentBuildIndex]);

    return (
        <div className="start">
            <div className="start-inner">
                <h2>Start by exploring the different options e.g. hats and hair!</h2>
            </div>
        </div>
    );
};

Start.propTypes = {
    onStart: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    currentBuildIndex: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({ currentBuildIndex: state.currentBuildIndex });

export default connect(mapStateToProps)(Start);
